export var EAuthCookies;
(function (EAuthCookies) {
    EAuthCookies["autoSignIn"] = "autoSignIn";
})(EAuthCookies || (EAuthCookies = {}));
export var EAuthStorageKey;
(function (EAuthStorageKey) {
    EAuthStorageKey["isLogged"] = "isLogged";
})(EAuthStorageKey || (EAuthStorageKey = {}));
export var ELoggedInfo;
(function (ELoggedInfo) {
    ELoggedInfo["isLogged"] = "1";
    ELoggedInfo["notLogged"] = "0";
})(ELoggedInfo || (ELoggedInfo = {}));
